import { datadogRum } from '@datadog/browser-rum'
import { nextjsPlugin } from '@datadog/browser-rum-nextjs'

import settings from 'shared/common/settings'

import { ALLOWED_TRACING_URLS_DATADOG } from './allowed-tracing-urls'
import { registerDatadogPropagator } from './register-datadog-propagator'

const APPLICATION_ID = '076d19be-c65e-4dc6-b0e4-67f3442a372b'
const CLIENT_TOKEN = 'pub3f04aa54ffffbfcb8c2b15f9ee5c10a9'

export function initDatadogRum(service: string): void {
  datadogRum.init({
    applicationId: APPLICATION_ID,
    clientToken: CLIENT_TOKEN,
    site: 'datadoghq.com',
    service,
    env: settings.appEnv,
    version:
      process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA ??
      process.env.NEXT_PUBLIC_APP_VERSION ??
      '0.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 10,
    traceSampleRate: 100,
    allowedTracingUrls: ALLOWED_TRACING_URLS_DATADOG,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    plugins: [nextjsPlugin()],
  })

  registerDatadogPropagator(service)
}
